import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const colors = [
  'background-base',
  'primary',
  'primary-dark',
  'primary-dark-contrasttext',
  'primary-dark-texttransparent',
  'primary-light',
  'primary-light-contrasttext',
  'primary-light-texttransparent',
  'primary-texttransparent',
  'primary-contrasttext',
  'secondary-dark',
  'secondary-dark-contrasttext',
  'secondary-dark-texttransparent',
  'secondary-light',
  'secondary-light-contrasttext',
  'secondary-light-texttransparent',
  'secondary-texttransparent',
  'secondary-contrasttext',
  'additional',
  'additional-dark',
  'additional-dark-texttransparent',
  'additional-texttransparent',
  'grey',
  'grey-dark',
  'grey-light',
  'text',
  'text-disabled',
  'text-secondary',
  'text-dark',
  'text-darktransparent',
  'text-light',
  'text-lighttransparent',
  'sale',
  'sale-contrasttext',
  'sale-dark',
  'sale-dark-contrasttext',
  'sale-dark-texttransparent',
  'sale-texttransparent',
  'info',
  'info-light',
  'info-light-contrasttext',
  'info-light-texttransparent',
  'info-dark',
  'info-dark-contrasttext',
  'info-dark-texttransparent',
  'info-texttransparent',
  'info-contrasttext',
  'warning',
  'warning-light',
  'warning-light-contrasttext',
  'warning-light-texttransparent',
  'warning-dark',
  'warning-dark-contrasttext',
  'warning-dark-texttransparent',
  'warning-texttransparent',
  'warning-contrasttext',
  'error',
  'error-light',
  'error-light-contrasttext',
  'error-light-texttransparent',
  'error-dark',
  'error-dark-contrasttext',
  'error-dark-texttransparent',
  'error-texttransparent',
  'error-contrasttext',
  'success',
  'success-light',
  'success-light-contrasttext',
  'success-light-texttransparent',
  'success-dark',
  'success-dark-contrasttext',
  'success-dark-texttransparent',
  'success-texttransparent',
  'success-contrasttext',
  'transparent',
  'sustainability',
  'sustainability-light',
  'sustainability-light-contrasttext',
  'sustainability-light-texttransparent',
  'sustainability-dark',
  'sustainability-dark-contrasttext',
  'sustainability-dark-texttransparent',
  'sustainability-texttransparent',
  'sustainability-contrasttext',
  'payback',
  'payback-light',
  'payback-dark',
  'joe',
  'joe-light',
  'joe-dark',
  'action-disabled',
  'separator',
  'accordion-toggle-icon',
  'backgrop',
  'linear-progress',
  'efficiency-darkgreen',
  'efficiency-mediumgreen',
  'efficiency-lightgreen',
  'efficiency-yellow',
  'efficiency-lightorange',
  'efficiency-darkorange',
  'efficiency-red',
];

const sizes = [
  'body1',
  'body2',
  'body3',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'body-2xl',
  'body-xl',
  'body-base',
  'body-sm',
  'body-xs',
  'headline-4xl',
  'headline-3xl',
  'headline-2xl',
  'headline-xl',
  'headline-base',
  'headline-sm',
];

const fontFamilies = [
  'family-primary',
  'family-secondary',
  'family-efficiency-label',
  'family-payback',
];

const customTwMerge = extendTailwindMerge<(typeof colors)[0]>({
  extend: {
    classGroups: {
      'text-color': [{ 'text-color': colors }],
      'font-family': [{ 'font-family': fontFamilies }],
      'text-size': [{ 'text-size': sizes }],
      'bg-color': [{ 'bg-color': colors }],
      'border-color': [{ 'border-color': colors }],
      'outline-color': [{ 'outline-color': colors }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
